var scene = document.getElementById('scene');
if (typeof(scene) != 'undefined' && scene != null) {
    var parallaxInstance = new Parallax(scene);
}

var faqs_animation = document.getElementById('faqs_animation');
if (typeof(faqs_animation) != 'undefined' && faqs_animation != null) {
    var parallaxInstance2 = new Parallax(faqs_animation);
}

var testimonials_animation = document.getElementById('testimonials_animation');
if (typeof(testimonials_animation) != 'undefined' && testimonials_animation != null) {
    var parallaxInstance3 = new Parallax(testimonials_animation);
}

var faqCloudsAnimation = document.getElementById('floating-clouds');
if (typeof(faqCloudsAnimation) != 'undefined' && faqCloudsAnimation != null) {
    var parallaxInstance4 = new Parallax(faqCloudsAnimation);
}
var md = new MobileDetect(window.navigator.userAgent);
console.log( md.mobile() );          // 'Sony'
console.log( md.phone() );           // 'Sony'
console.log( md.tablet() );
// DISABLE PARALLAX INSTANCES IN MOBILE
if(jQuery(window).width() < 992 || md.mobile() != null || md.phone() != null || md.tablet() != null) {
    setTimeout(function() {
        if(parallaxInstance != undefined) {
            parallaxInstance.disable();
        }
        if(parallaxInstance2 != undefined) {
            parallaxInstance2.disable();
        }
        if(parallaxInstance3 != undefined) {
            parallaxInstance3.disable();
        }
        if(parallaxInstance4 != undefined) {
            parallaxInstance4.disable();
        }  
    }, 1000);
}


// Create our number formatter.
var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});


jQuery(document).ready(function ($) {
 
    function PMT(ir, np, pv, fv, type) {
        /*
         * ir   - interest rate per month
         * np   - number of periods (months)
         * pv   - present value
         * fv   - future value
         * type - when the payments are due:
         *        0: end of the period, e.g. end of month (default)
         *        1: beginning of period
         */
        var pmt, pvif;

        fv || (fv = 0);
        type || (type = 0);

        if (ir === 0)
            return -(pv + fv)/np;

        pvif = Math.pow(1 + ir, np);
        pmt = - ir * pv * (pvif + fv) / (pvif - 1);

        if (type === 1)
            pmt /= (1 + ir);

        return pmt;
    }

    function get_number_of_payments(cycle) {
        switch(cycle) {
            case 'weekly':
                return 52;
                break;
            case 'fortnightly':
                return 26
                break;
            case 'monthly':
                return 12
                break;
            default:
                return 52;
                break;
        }
    }

    function get_repayment_label(cycle) {
        switch(cycle) {
            case 'weekly':
                return 'Weekly Repayment';
                break;
            case 'fortnightly':
                return 'Fortnightly Repayment';
                break;
            case 'monthly':
                return 'Monthly Repayment';
                break;
            default:
                return 'Weekly Repayment';
                break;
        }
    }


    const range = document.querySelector(".range");
    const bubble = document.querySelector(".bubble");
    const overlay = document.querySelector(".range-overlay");
    if (typeof(range) != 'undefined' && range != null) {
        range.addEventListener("change", function() {
            setBubble(range, bubble, overlay);
        });
        range.addEventListener("input", function() {
            setBubble(range, bubble, overlay);
        });
        setBubble(range, bubble, overlay);
    }

    
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function setBubble(range, bubble, overlay) {
        var val = range.value;
        var min = range.min;
        var max = range.max;
        // $('#loan_amount').val(val);
        var newVal = Number(((val - min) * 100) / (max - min));
        if(newVal < 9) {
            newVal = 8;
        }
        if(newVal > 94) {
            newVal = 94;
        }
        console.log(val);
        bubble.innerHTML = '$'+numberWithCommas(val);
        var diff = (8 - newVal) * 0.15;
        // Sorta magic numbers based on size of the native UI thumb
        bubble.style.left = 'calc('+newVal+'% + '+diff+'px)';
        overlay.style.width = 'calc('+newVal+'% + '+diff+'px)';
    }


    function run_calculation() {


        if ($('#loan_amount')) {


            var previous_borrow_amount = Number($('.value.borrow').text().replace(/[^0-9.-]+/g,""));
            var previous_interest_and_fees = Number($('.value.interest_and_fees').text().replace(/[^0-9.-]+/g,""));
            var previous_loan_amount_total = Number($('.value.total').text().replace(/[^0-9.-]+/g,""));
            var previous_repayments = Number($('.value.repayment').text().replace(/[^0-9.-]+/g,""));


            var borrow_amount = parseInt($('#loan_amount').val());
    
            var fixed_fee = parseInt($('#fixed_fee').val());
            var loan_amount = borrow_amount + fixed_fee;

            var years = 1; //this never changes
            var rate = $('#return_rate').val();
            var n = get_number_of_payments(jQuery("input[name='frequency']:checked").val());

            var repayment_label = get_repayment_label(jQuery("input[name='frequency']:checked").val());
            jQuery('.label.repayment_label').text(repayment_label);


            var repayments = (PMT(rate / n, years * n, loan_amount).toFixed(0)) * -1;
            var loan_amount_total = repayments * n;
            var interest_and_fees = loan_amount_total - borrow_amount;


            $('.value.borrow').countTo({
                from: previous_borrow_amount,
                to: borrow_amount,
                speed: 300,
                refreshInterval: 50,
                onComplete: function(value) {
                    //console.debug(this);
                }
            });

            $('.value.interest_and_fees').countTo({
                from: previous_interest_and_fees,
                to: interest_and_fees,
                speed: 300,
                refreshInterval: 50,
                onComplete: function(value) {
                    //console.debug(this);
                }
            });

            $('.value.total').countTo({
                from: previous_loan_amount_total,
                to: loan_amount_total,
                speed: 300,
                refreshInterval: 50,
                onComplete: function(value) {
                    //console.debug(this);
                }
            });

            $('.value.repayment').countTo({
                from: previous_repayments,
                to: repayments,
                speed: 300,
                refreshInterval: 50,
                onComplete: function(value) {
                    //console.debug(this);
                }
            });

            //$('.value.borrow').text(formatter.format(borrow_amount));
            //$('.value.interest_and_fees').text(formatter.format(interest_and_fees));
            //$('.value.total').text(formatter.format(loan_amount_total));
            //$('.value.repayment').text(formatter.format(repayments));
        }
    }

    run_calculation();


    $(".frequency_wrap .btn").click(function() {
        setTimeout(function() {
            run_calculation();
        }, 0);
        
    });

    $('#loan_amount').bind('keyup mouseup change', function () {
        run_calculation();
    });


    setTimeout(function() {
        var topbar = $('.topbar_wrapper');
        var topbar_height = topbar.outerHeight();
        TweenLite.to($('body'), 0, { y: -topbar_height });
        TweenLite.to(topbar, 0, { delay: 1, opacity: 1 });
        TweenLite.to($('body'), 0.5, { delay: 2, ease: Power4.easeInOut, y:0, clearProps: 'all' });
    }, 400);



    // HEADER SCRIPTS
    // scriptOnReady
    TweenLite.to(jQuery(".search-box"), 0, {ease: Cubic.easeInOut, width: '0%', opacity: 0});
    TweenLite.to(jQuery(".search-box-sticky"), 0, {ease: Cubic.easeInOut, width: '0%', opacity: 0});
    jQuery('#overlay').css('top', jQuery('header.banner').outerHeight() + jQuery('.topbar_wrapper').outerHeight());

    jQuery('.search-close').click(function() {
        jQuery( ".search-box" ).removeClass('active');
        TweenLite.to(jQuery(".search-box"), 0.5, {ease: Cubic.easeInOut, width: '0%', opacity: 0});
    });

    jQuery('#search-icon').click(function() {
        TweenLite.to(jQuery(".search-box"), 0.5, {ease: Cubic.easeInOut, width: $('#desktop-menu').width(), opacity: 1});
        jQuery( ".search-box" ).addClass('active');
        jQuery( ".search-box input" ).focus();
    });

    jQuery('.search-close-sticky').click(function() {
        jQuery( ".search-box-sticky" ).removeClass('active');
        TweenLite.to(jQuery(".search-box-sticky"), 0.5, {ease: Cubic.easeInOut, width: '0%', opacity: 0});
    });

    jQuery('#search-icon-sticky').click(function() {
        TweenLite.to(jQuery(".search-box-sticky"), 0.5, {ease: Cubic.easeInOut, width: $('#desktop-menu-sticky').width(), opacity: 1});
        jQuery( ".search-box-sticky" ).addClass('active');
        jQuery( ".search-box-sticky input" ).focus();
    });

    var triggerOffset = 200
    jQuery(window).scroll(function() {
        if(window.innerWidth < 992) {
            triggerOffset = 400;
        }
        if (jQuery(this).scrollTop() > triggerOffset) {
            jQuery('#sticky-header').addClass('visible');
            jQuery('#overlay').css('top', jQuery('#sticky-header').outerHeight());
        } else {
            jQuery('#sticky-header').removeClass('visible');
            jQuery('#overlay').css('top', jQuery('header.banner').outerHeight() + jQuery('.topbar_wrapper').outerHeight());
        }
    });

     // MOBILE MENU TOGGLE
    jQuery(jQuery("#mobile-menu > li")).each(function(i) { 
        TweenLite.to(jQuery(this), 0.2, {opacity:0, y: "-10%"});
    });

    function animateMenu(element) {
        var $hamburger = jQuery('#hamburger-icon'),
            $hamburgerSticky = jQuery('#hamburger-icon-sticky'),
            $mobilemenu = jQuery("#overlay");
            
        jQuery('body').toggleClass('menu-open');
        jQuery('.overlay-shadow').toggleClass('open');
        if(element.hasClass("open")) {

            jQuery(jQuery("#mobile-menu > li").get().reverse()).each(function(i) { 
                TweenLite.to(jQuery(this), 0.2, {delay: 0.1 * i, ease: Power4.easeInOut, opacity:0, y: "-10%"});
            });

            TweenLite.to($mobilemenu, 0.5, {ease: Power4.easeInOut, height:0});
            
            TweenMax.to('#overlay .phone_number_wrap', 0.3, {opacity: 0, ease: Power4.easeInOut, y: "-10%"});

            $mobilemenu.removeClass("open");
            element.removeClass("open");

        } else {

            jQuery("#mobile-menu > li").each(function(i) {
                TweenLite.to(jQuery(this), 0.4, {delay: 0.05 * i, ease: Power4.easeInOut, opacity: 1, y: "0%"});
            });

            TweenLite.set($mobilemenu, {ease: Power4.easeInOut, height:"auto"});

            TweenMax.to('#overlay .phone_number_wrap', 0.3, {delay: 0.5, opacity: 1, ease: Power4.easeInOut, y: "0%"});
            
            TweenLite.from($mobilemenu, 0.5, {ease: Power4.easeInOut, height:0});
            element.addClass("open");
            $mobilemenu.addClass("open");
        }
    }

    jQuery("#gnavBtn").click(function() {
        animateMenu(jQuery(this));
    });

    jQuery("#gnavBtn-sticky").click(function() {
        animateMenu(jQuery(this));
    });

    // mobile menu scrolling
    jQuery('#mobile-menu-scroller').slimScroll({
        height: window.innerHeight - jQuery('header.banner').outerHeight() - jQuery('.topbar_wrapper').outerHeight() - jQuery('.search-box-mobile').outerHeight(),
        // height: '90vh',
        alwaysVisible: true,
        size: '4px',
    });

    // mobile submenu toggle
    jQuery('body').on('click', '#mobile-menu .menu-item-has-children > a .dropdown-arrow', function(e) {
        e.preventDefault();
        var $this = jQuery(this),
            $submenu = $this.parent().siblings('.sub-menu');
            
        $this.toggleClass("fa-angle-down fa-angle-up");
        if(!$this.hasClass("expanded")){
            TweenLite.set($submenu, {
                height: "auto",
                opacity: 1,
            });
            TweenLite.from($submenu, 0.5, {
                height: 0,
                opacity: 0,
                ease: Cubic.easeInOut,
            });
            $this.addClass("expanded");
            $submenu.addClass("expanded");
            TweenMax.to($submenu.find('li'), 1, {opacity: 1});
        } else {
            $this.removeClass("expanded");
            $submenu.removeClass("expanded");
            TweenLite.to($submenu, 0.5, {
                height: 0,
                opacity: 0,
                ease: Cubic.easeInOut,
            });
            TweenMax.to($submenu.find('li'), 1, {opacity: 0});
        }
    });

    jQuery('.tiles_wrapper .block_single .inner .heading').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    jQuery('.col-title').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    jQuery('.col-slide-content').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    jQuery('.col-body').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    jQuery('.col-twins').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });
    
    jQuery('.col-img').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    // FAQS
    $('body').on('click', '.faq-question', function() {
        var container = $(this).parents(".faq-group");
        var answer = container.find(".faq-answer");
        var trigger = container.find(".faq-expand");
    
        $(answer).slideToggle( function() {
            $('img', trigger).toggleClass('expanded');
            if ($(this).is(':visible')) {
                $(this).css('display', 'block');
            }
            $.fn.matchHeight._update();
        });
    });
    
    $('#faq-search').on("change keyup paste input",function() {
        var txt = $(this).val();
        
        if($(this).val() != '') {
            $(this).parent().addClass('active');
            var validCount = 0;
            $('.faq-group').each(function() {
                if($(this).text().toUpperCase().indexOf(txt.toUpperCase()) == -1){
                    $(this).hide();
                    $(this).addClass('disabled').removeClass('enabled');
                } else {
                    $(this).show();
                    $(this).addClass('enabled').removeClass('disabled');
                    validCount++;
                }
            });

            $('.faq-group-wrapper').each(function() {
                if($(this).find('.faq-group.enabled').length == 0) {
                    $(this).parent('.faq-cat-wrapper').hide();
                    $(this).addClass('disabled').removeClass('enabled');
                } else {
                    $(this).parent('.faq-cat-wrapper').show();
                    $(this).addClass('enabled').removeClass('disabled');
                    $(this).addClass('enabled').removeClass('disabled');
                }
            });

            if($('.faq-group-wrapper.enabled').length == 0) {
                $('.no-faq-results-all').show();
            } else {
                $('.no-faq-results-all').hide();
            }
        } else {
            $('.no-faq-results-all').hide();
            $('.faq-cat-wrapper').show();
            $('.faq-group').show();
            $('.faq-group').addClass('enabled').removeClass('disabled');
            $('.faq-group-wrapper').addClass('enabled').removeClass('disabled');
            $(this).parent().removeClass('active');
        }
    });

    $('#faq-search-clear').click(function() {
        $('#faq-search').val('');
        $('.faq-group').show();
        $('#faq-search').change();
        $(this).parent().removeClass('active');
    });

    // RESIZE
    jQuery(window).resize(function() {
        jQuery('#side_menu_wrapper').css('top', jQuery('header.banner').outerHeight() + jQuery('.topbar_wrapper').outerHeight());

        // DISABLE PARALLAX INSTANCES IN MOBILE
        if(jQuery(window).width() < 992 || md.mobile() != null || md.phone() != null || md.tablet() != null) {
            if(parallaxInstance != undefined) {
                parallaxInstance.disable();
            }
            if(parallaxInstance2 != undefined) {
                parallaxInstance2.disable();
            }
            if(parallaxInstance3 != undefined) {
                parallaxInstance3.disable();
            }
            if(parallaxInstance4 != undefined) {
                parallaxInstance4.disable();
            }
        }

        setTimeout(function() {
            $.fn.matchHeight._update();
        }, 1000);
    });
});

(function($) {
    $.fn.countTo = function(options) {
        // merge the default plugin settings with the custom options
        options = $.extend({}, $.fn.countTo.defaults, options || {});
        
        // how many times to update the value, and how much to increment the value on each update
        var loops = Math.ceil(options.speed / options.refreshInterval),
            increment = (options.to - options.from) / loops;
        
        return $(this).each(function() {
            var _this = this,
                loopCount = 0,
                value = options.from,
                interval = setInterval(updateTimer, options.refreshInterval);
            
            function updateTimer() {
                value += increment;
                loopCount++;
                $(_this).html(formatter.format(value.toFixed(options.decimals)));
                
                if (typeof(options.onUpdate) == 'function') {
                    options.onUpdate.call(_this, value);
                }
                
                if (loopCount >= loops) {
                    clearInterval(interval);
                    value = options.to;
                    
                    if (typeof(options.onComplete) == 'function') {
                        options.onComplete.call(_this, value);
                    }
                }
            }
        });
    };
    
    $.fn.countTo.defaults = {
        from: 0,  // the number the element should start at
        to: 100,  // the number the element should end at
        speed: 1000,  // how long it should take to count between the target numbers
        refreshInterval: 100,  // how often the element should be updated
        decimals: 0,  // the number of decimal places to show
        onUpdate: null,  // callback method for every time the element is updated,
        onComplete: null,  // callback method for when the element finishes updating
    };
})(jQuery);